module.exports = __webpack_public_path__ + "static/media/as_item4_price.b38191b3.png";